import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import store from "@redux/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import common_en from "./translations/en/language.json";
import common_ge from "./translations/ge/language.json";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

i18next.init({
  lng: "en",
  debug: false,
  resources: {
    en: {
      common: common_en,
    },
    de: {
      common: common_ge,
    },
  },
});

root.render(
  <I18nextProvider i18n={i18next}>
    <Provider store={store}>
      <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
        <Suspense fallback={false}>
          <App />
          <ToastContainer stacked />
        </Suspense>
      </BrowserRouter>
    </Provider>
  </I18nextProvider>
);

reportWebVitals();
